import React, { Component, Fragment } from 'react';
import * as customers from 'customers/actions/customers';
import { connect } from 'react-redux';
import { DetailContainer } from 'customers/DetailContainer';
import Loading from 'apa/components/Loading';
import BootstrapTable from 'react-bootstrap-table-next'
import { ButtonGroup } from 'reactstrap';
import NewReportButton from 'customers/reports/NewReportButton';
import Date from 'apa/components/Date';
import { NavLink } from 'react-router-dom';
import DeleteReport from 'customers/reports/DeleteReport';
import autobind from 'autobind-decorator';
import ReportPrintButton from 'customers/reports/ReportPrintButton';
import { BaseUrl } from '../../BaseUrl/BaseUrl';


@connect(
	state => {
		return {
			customers: state.customers,
			auth: state.apa,
		}
	},
	dispatch => {
		return {
			fetchCustomer: (customer_id, callback) => {
				dispatch(customers.fetchCustomer(customer_id, callback))
			}
		}
	}
)
export default class ReportList extends Component {


	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			reports: null,
			customer: null
		};
	}

	componentDidMount() {
		this.fetchReports();

	}

	@autobind
	fetchReports() {
		this.setState(
			{
				isLoading: true
			}
		);
		const headers = { 'Content-Type': 'application/json' };
		headers['Authorization'] = `Token ${this.props.auth.token}`;
		const id = this.props.match.params.id;
		fetch(
			`${BaseUrl}/api/customers/${id}/reports/`,
			{ headers }
		).then(res => res.json())
			.then(
				reports => {
					this.props.fetchCustomer(this.props.match.params.id,
						c => this.setState({
							customer: c,
							isLoading: false,
							reports: reports
						})
					)
				}
			)

	}

	render() {
		const id = this.props.match.params.id;
		if (this.state.isLoading)
			return <Loading />;
		const columnList = [
			{
				dataField: 'manual_type',
				text: 'Grund der Begehung',
				formatter: (cell) => cell ? 'GFBU' : 'Begehungsbericht'
			},
			{
				dataField: 'name',
				text: 'Name',
			},
			{
				dataField: 'created_at',
				text: 'Erstellt',
				formatter: cell => <Date date={cell} />
			},
			{
				dataField: 'updated_at',
				text: 'Bearbeitet',
				formatter: cell => <Date date={cell} />
			},
			{
				dataField: 'sector',
				text: 'Bereich',
			},
			{
				dataField: 'id',
				text: '',
				isDummyField: true,
				formatter: (cell, row) =>
					<ButtonGroup>
						<NavLink to={`/customer/${id}/reports/${row.id}`} className='btn btn-primary'>
							<i className={'fa fa-edit'}> </i>
						</NavLink>
						<ReportPrintButton customerId={id} reportId={row.id} />
						<DeleteReport report={row} callback={this.fetchReports} />
					</ButtonGroup>
			}

		];

		return (
			<DetailContainer id={id}>
				<h1>{this.state.customer.name}</h1>
				<NewReportButton id={id} />
				<BootstrapTable
					responsive
					bootstrap4
					columns={columnList} keyField='id' data={this.state.reports}
					expandRow={{
						renderer: row => {
							const { last_print } = row
							if (!last_print)
								return <p>Bericht noch nicht gedruckt.</p>
							else {
								return <Fragment>
									<ul>
										<li>
											<a href={last_print.file}>{last_print.file}</a>
										</li>
										{
											last_print.attachments.map(
												(attachment, index) =>
													<li key={`aaa_${index}`}>
														<a href={attachment.file}>{attachment.file}</a>
													</li>
											)
										}
									</ul>
								</Fragment>
							}

						}
					}}
				/>
			</DetailContainer>
		)
	}
}

